import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Button, Card, CardBody, Col, Container, CardHeader, Row, Spinner, ListGroup, ListGroupItem } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty } from "lodash";

import Select from "react-select";
//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { getClient, resetClientState } from "../../../store/client/action";
import { resetDepartmentState, getDeptStructure, getDepartment as onGetDepartments, addNewDepartment as onAddNewDepartment, updateDepartment as onUpdateDepartment, deleteDepartment as onDeleteDepartment, getDepartmentLoading, getDepartment } from "../../../store/department/action";

const Structure = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, clients, clientLoading, structures, departments, departmentLoading, companies, companyLoading, isDepartmentCreated, isDepartmentSuccess, loading, error } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    structures: state.Department.structures,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    isDepartmentCreated: state.Department.isDepartmentCreated,
    isDepartmentSuccess: state.Department.isDepartmentSuccess,
    loading: state.Department.loading,
    error: state.Department.error,
  }));

  const [departmentList, setDepartmentList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [departmentSelect, setDepartmentSelect] = useState(null);
  const [structure, setStructure] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (companySelected && companySelected.value) {
      const obj = JSON.parse(localStorage.getItem("authUser"));

      handleGetDepartement(companySelected.value);
    }
  }, [companySelected]);

  useEffect(() => {
    if (!isEmpty(structures)) setStructure(structures);
    else setStructure([]);
  }, [structures]);

  useEffect(() => {
    var data = [];
    var opt = [];
    departments.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (departments.length > 0) {
      setDepartmentList(data);
    }
    else
    {
      setDepartmentList([]);
    }
  }, [departments]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetDepartement = (id) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: id }));
  };

  const handleGetDepartementStructure = (id) => {
    dispatch(getDeptStructure({ departmentId: id }));
  };

  document.title = "Struktur | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Organisasi" pageTitle="Struktur" />
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Struktur Organisasi &nbsp;
                    {isLoading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...</Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...</Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                  <div
                    className="row gx-2"
                    style={{
                      width: "700px",
                    }}>
                    <div className="col">
                      <div className="position-relative">
                        <Select
                          name="client"
                          value={clientSelected}
                          placeholder="Pilih Grup Usaha"
                          isDisabled={userType === "admin" || userType === "client" ? false : true}
                          onChange={(e) => {
                            setCompanyList([]);
                            setDepartmentList([]);
                          }}
                          options={clientList}> </Select>
                        <div
                          className="position-absolute"
                          style={{
                            top: "12px",
                            right: "45px",
                          }}>
                          {clientLoading && (
                            <Spinner color="primary" size="sm">
                              Loading...
                            </Spinner>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="position-relative">
                        <Select
                          name="company"
                          value={companySelected}
                          placeholder="Pilih Perusahaan"
                          isDisabled={userType === "admin" || userType === "client" ? false : true}
                          onChange={(e) => {
                            setDepartmentList([]);
                            setDepartmentSelect(null);
                            handleGetDepartement(e.value);
                          }}
                          options={companyList}> </Select>
                        <div
                          className="position-absolute"
                          style={{
                            top: "12px",
                            right: "45px",
                          }}>{companyLoading && (
                            <Spinner color="primary" size="sm">
                              Loading...
                            </Spinner>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="position-relative">
                        <Select
                          name="department"
                          value={departmentSelect}
                          placeholder="Pilih Departemen"
                          onChange={(e) => {
                            setDepartmentSelect(e);
                            handleGetDepartementStructure(e.value);
                          }}
                          options={departmentList}> </Select>
                        <div
                          className="position-absolute"
                          style={{
                            top: "12px",
                            right: "45px",
                          }}>{departmentLoading && (
                            <Spinner color="primary" size="sm">
                              Loading...
                            </Spinner>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <ListGroup className="nested-list nested-sortable">
                  <ListGroupItem className="nested-1">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <h5 className="fs-16 mb-3">{structure.name}</h5>
                        <div className="fs-14 mb-3">
                          {structure.department_position &&
                            structure.department_position.map((odp, idp) => {
                              return (
                                <div className="fs-14 mb-2" key={idp}>
                                  {odp.name}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                    <ListGroup className="nested-list nested-sortable">
                      {structures.cld_dep &&
                        structures.cld_dep.map((ob, i) => {
                          return (
                            <ListGroupItem className="nested-2" key={i}>
                              <div className="d-flex align-items-center">
                                <div className="flex-grow-1">
                                  <h5 className="fs-16 mb-3">{ob.name}</h5>
                                  <div className="fs-14 mb-3">
                                    {ob.department_position &&
                                      ob.department_position.map((odp, idp) => {
                                        return (
                                          <div className="fs-14 mb-2" key={idp}>
                                            {odp.name}
                                          </div>
                                        );
                                      })}
                                  </div>
                                </div>
                              </div>
                              <ListGroup className="nested-list nested-sortable">
                                {ob.cld_dep &&
                                  ob.cld_dep.map((obj, idx) => {
                                    return (
                                      <ListGroupItem className="nested-3" key={idx}>
                                        <div className="d-flex align-items-center">
                                          <div className="flex-grow-1">
                                            <h5 className="fs-16 mb-3">{obj.name}</h5>
                                            <div className="fs-14 mb-3">
                                              {obj.department_position &&
                                                obj.department_position.map((odp, idp) => {
                                                  return (
                                                    <div className="fs-14 mb-2" key={idp}>
                                                      {odp.name}
                                                    </div>
                                                  );
                                                })}
                                            </div>
                                          </div>
                                        </div>
                                        <ListGroup className="nested-list nested-sortable">
                                          {obj.cld_dep &&
                                            obj.cld_dep.map((object, index) => {
                                              return (
                                                <ListGroupItem className="nested-4" key={index}>
                                                  <div className="d-flex align-items-center">
                                                    <div className="flex-grow-1">
                                                      <h5 className="fs-16 mb-3">{object.name}</h5>
                                                      <div className="fs-14 mb-3">
                                                        {object.department_position &&
                                                          object.department_position.map((odp, idp) => {
                                                            return (
                                                              <div className="fs-14 mb-2" key={idp}>
                                                                {odp.name}
                                                              </div>
                                                            );
                                                          })}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </ListGroupItem>
                                              );
                                            })}
                                        </ListGroup>
                                      </ListGroupItem>
                                    );
                                  })}
                              </ListGroup>
                            </ListGroupItem>
                          );
                        })}
                    </ListGroup>
                  </ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Structure;
